/**
 * The one thing a form page keeps in the browser (SFM-D10): the session's
 * secret, in sessionStorage, so a reload or a moment in another app does not
 * ask for the date of birth again. Never the answers: they are saved on the
 * server, encrypted, at each Next.
 *
 * sessionStorage, not localStorage: it ends with the tab, which on a shared
 * phone is the point. A private window that refuses storage just asks again.
 */
const key = (token: string): string => `rxform:${token}`;

export function rememberSession(token: string, secret: string): void {
  try {
    sessionStorage.setItem(key(token), secret);
  } catch {
    // Storage refused: the date of birth is asked again after a reload.
  }
}

export function storedSession(token: string): string | null {
  try {
    return sessionStorage.getItem(key(token));
  } catch {
    return null;
  }
}

export function forgetSession(token: string): void {
  try {
    sessionStorage.removeItem(key(token));
  } catch {
    // Nothing kept, nothing to forget.
  }
}

/** A one-time key per send, so a retried submit is one submit. */
export function newNonce(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
}
